import { FixaSkeleton } from "../../../shared/wrappers/FixaSkeleton/FixaSkeleton";
import ProductSearchCss from "../../pages/product-search-page/product-search.module.css";

export const ProductSearchHistorySkeleton = () => {
  return (
    <div className={ProductSearchCss["search-history-skeleton"]}>
      <FixaSkeleton height="40px" />
      <FixaSkeleton height="40px" />
      <FixaSkeleton height="40px" />
      <FixaSkeleton height="40px" />
    </div>
  );
};
